// import { Link } from 'react-router-dom';
import styled from 'styled-components';

export const ContainerFluid = styled.div`
// border:2px dashed red;
width:100%;
background: #FCFCFC;
padding-bottom:100px;
padding-top:100px;

`;



export const Container = styled.div
.attrs(() => ({
  className: 'container-custom',
}))`
    min-height: 396px;
    background: rgba(0, 165, 104, 0.9);
    box-shadow: 0px 20px 40px rgba(0, 165, 104, 0.3);
    border-radius: 20px;
`;

export const HeadingText = styled.h1
.attrs(() => ({
  className: 'p-16',
}))`
width: 289px;
min-height: 138px;
font-family: 'Cabinet Grotesk';
font-style: normal;
font-weight: 800;
font-size: 40px;
line-height: 115.5%;
color: #FFFFFF;
margin-bottom:0px !important;

@media screen and (max-width: 425px) {
    width:auto !important;
}

`;
export const CtaText = styled.p
.attrs(() => ({
  className: '',
}))`
font-family: 'Cabinet Grotesk';
font-style: normal;
font-weight: 500;
font-size: 32px;
line-height: 103%;
/* identical to box height, or 33px */
color: #FFFFFF;
`;



export const Button  = styled.a
.attrs(() => ({
  className: ' btn btn-large btn-flat  ',
}))`
background: #DFFFF3;
border-radius: 11.2069px;
:hover{
background: linear-gradient(113.57deg, rgba(0, 165, 104, 0.2) 22.35%, rgba(0, 165, 104, 0.05) 71.76%);
color: rgba(74, 74, 74, 0.8);
}
font-family: 'Cabinet Grotesk' !important;
font-style: normal;
font-weight: 700;
font-size: 14.9425px;
line-height: 135.5%;
width:200.84px;
height: 65px !important;
color: rgba(74, 74, 74, 0.8);
margin-top:10px;
display:flex;
    span{
        font-family: 'Cabinet Grotesk' !important;
        font-style: normal;
        font-weight: 500;
        font-size: 9.71264px;
        line-height: 135.5%;
        color: rgba(74, 74, 74, 0.8);
    }

@media screen and (max-width: 500px) {
font-size: 1.8rem;
padding: 9px 1.5rem;
}
@media screen and (max-width: 400px) {
font-size: 1.4rem;
}
`;
